// extracted by mini-css-extract-plugin
module.exports = {"burger":"Burger_burger__NinLt","burgerActive":"Burger_burgerActive__5yosg","primaryTheme":"Burger_primaryTheme__8C2db","secundaryTheme":"Burger_secundaryTheme__JBZc4"};